/**
 * Suspense fallback for lazily-loaded route screens (see App.jsx).
 * `react-router`'s RouterProvider renders route elements inside a Suspense
 * boundary, so this is only a visual placeholder while a chunk downloads.
 */
export default function RouteFallback() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <span
        className="material-symbols-outlined animate-spin text-4xl text-primary"
        aria-hidden="true"
      >
        progress_activity
      </span>
      <span className="sr-only">Loading…</span>
    </div>
  );
}
